import { defineType } from 'sanity';

export const showcaseGrid = defineType({
    name: 'showcaseGrid',
    title: 'Showcase Grid section',
    type: 'object',
    fields: [
        {
            name: 'title',
            title: 'Title',
            type: 'localizedString',
        },
        {
            name: 'dishes',
            title: 'Dishes',
            type: 'array',
            of: [
                {
                    type: 'object',
                    fields: [
                        {
                            name: 'name',
                            title: 'Name',
                            type: 'localizedString',
                        },
                        {
                            name: 'description',
                            title: 'Description',
                            type: 'localizedString',
                        },
                        {
                            name: 'image',
                            title: 'Image',
                            type: 'seoOptimizedImageUrl',
                        },
                    ],
                },
            ],
        },
        {
            name: 'variant',
            title: 'Variant',
            type: 'string',
            options: {
                list: [
                    { title: 'Variant A', value: 'A' },
                    { title: 'Variant B', value: 'B' },
                    { title: 'Variant C', value: 'C' },
                ],
            },
        },
    ],
    preview: {
        select: {
            title: 'title',
        },
        prepare({ title }) {
            return {
                title: `Showcase Grid: ${title['en'] || title['sr']}`,
            };
        },
    },
});
